import { Injectable, inject, Injector } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {ContactUsActionTypes, ContactUsActions} from '../actions/contact-us.actions';
import { switchMap, withLatestFrom, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import { ContactUsService } from '../../../services/contact-us.service';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {updateInfoType} from '../../../shareModel';
import {TranslateService} from '@ngx-translate/core';
import { AddContactUsParams } from '../contact-us.model';



@Injectable()
export class ContactUsEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private contactUsService = inject(ContactUsService);
  private injector = inject(Injector);


  constructor() {}

  AddContactUs$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.ContactUsActionTypes.AddContactUs),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const payload = { ...action.payload, otp: user.otp };
      return this.contactUsService.AddContact(payload).pipe(
        map((res: any) => {
          const updateRes: UpdateInfoModel = {
            result: false,
            msg: '',
            errmsg: 'Error',
            type: updateInfoType.AddContactUs
          };
          if (res.Flag) {
            return new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: true, msg: this.injector.get(TranslateService).instant('Update Success') });
          } else {
            return new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: this.injector.get(TranslateService).instant('Update Failed') });
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const updateRes: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.AddContactUs
          };
          return of(new featureActions.UpdateInfoFailAction(updateRes));
        })
      );
    })
  ));
}
